import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import FloatingContact from "./components/layout/FloatingContact";
import ScrollToTop from "./components/ScrollToTop";
import { ThemeProvider } from "./hooks/useTheme";
import { SITE } from "./config/site";

import Home from "./pages/Home";
import Services from "./pages/Services";
import Software from "./pages/Software";
import Etex from "./pages/Etex";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Brochure from "./pages/Brochure";
import BetonKarot from "./pages/BetonKarot";
import NotFound from "./pages/NotFound";

const organizationLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: SITE.name,
  alternateName: SITE.shortName,
  url: SITE.url,
  logo: SITE.url + SITE.logo,
  email: SITE.email,
  telephone: SITE.phone,
  foundingDate: SITE.founded,
  address: {
    "@type": "PostalAddress",
    streetAddress: "Fulya, Büyükdere Cd. Lale İş Merkezi No: 62/31",
    addressLocality: "Şişli",
    addressRegion: "İstanbul",
    postalCode: "34349",
    addressCountry: "TR",
  },
  sameAs: [SITE.social.linkedin, SITE.social.instagram, SITE.social.youtube],
};

function App() {
  return (
    <ThemeProvider>
    <Router>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(organizationLd)}</script>
      </Helmet>
      <div className="dm">
        <ScrollToTop />
        <Navbar />
        <main style={{ paddingTop: "var(--nav-h)" }}>
          <Suspense fallback={null}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/hizmetler" element={<Services />} />
              <Route path="/services" element={<Services />} />
              <Route path="/yazilimlar" element={<Software />} />
              <Route path="/softwares" element={<Software />} />
              <Route path="/etex" element={<Etex />} />
              <Route path="/iletisim" element={<Contact />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/tanitim" element={<Brochure />} />
              <Route path="/brosur" element={<Brochure />} />
              <Route path="/araclar/beton-karot" element={<BetonKarot />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
        <FloatingContact />
      </div>
    </Router>
    </ThemeProvider>
  );
}

export default App;
